<template>
    <div class="rq-container content-wrapper justify-content-center h-100">
        <div class="row justify-content-center">
            <div class="col-auto">
                <div class="display-6 text-gray-500">{{ message }}</div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { computed } from "vue";
    import { useRoute } from "vue-router";
    const route = useRoute();
    const message = computed(() => _.trimStart(`${route?.meta?.label || ""} Coming Soon`));
</script>